<ng-container *ngIf="isBtn">
  <jhi-bary-button [outline]="true" [label]="labelkey | translate" class="mx-1" (click)="loadEmail()" *ngIf="isDisplay()"></jhi-bary-button>
</ng-container>

<ng-container *ngIf="!isBtn">
  <span class="mx-1" (click)="loadEmail()">{{ emailTransporter }}</span>
</ng-container>
